module.exports = __webpack_public_path__ + "static/img/ARAD4S_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4S_2.png
// module id = TqSy
// module chunks = 0